import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Filters, DateRangeFilter, PageFilter } from './filterSectionStyles';
import { Input, Icon, Select, message, InputNumber } from 'antd';
import { DateTimePicker } from 'react-rainbow-components';
import { getTagValues } from '../../utils/services/mailRoomAPI';
import { MailRoomContext } from '../../context/mailRoomContext';
import moment from 'moment';
import { DEFAULT_DATE_TIME_FORMAT } from '../../utils/helper';
import { withTranslation } from 'react-i18next';
import { MAIL_ROOM_DOCUMENT_FILTERS } from './translationValues';

const NAMESPACES=['MAIL_ROOM_DOCUMENT_FILTERS']

const { Search } = Input;
const { Option, OptGroup } = Select;

const FiltersContainer = ({ t }) => {
  const {
    searchValue,
    setSearchValue,
    setSearchByDocName,
    selectedTags,
    setSelectedTags,
    setPayloadTags,
    startAndEndDate,
    setStartAndEndDate,
    setPageFilter,
  } = useContext(MailRoomContext);

  const [showTags, setShowTags] = useState(false);
  const [tagValues, setTagValues] = useState([]);
  const [modifiedTagsList, setModifiedTagsList] = useState([]);

  useEffect(() => {
    fetchTagValues();
  }, []);

  useEffect(() => {
    updateTagsList('');
  }, [tagValues, selectedTags]);

  const fetchTagValues = useCallback(async () => {
    let tagResp = await getTagValues();
    if (tagResp.errors && tagResp.errors.length === 0) {
      if (tagResp && tagResp.data) {
        setTagValues(tagResp.data);
      }
    }
  }, []);

  const onTagChange = value => {
    setSelectedTags(value);
    let list = [];
    let selectedTag = [];
    let allTagList = JSON.parse(JSON.stringify(tagValues));
    allTagList.filter(item => {
      selectedTag = [];
      item.tagInfo.some(tags =>
        value.find(val => {
          if (val === tags) {
            selectedTag.push(tags);
            item.tagInfo = selectedTag;
            for (var i = 0; i < list.length; i++) {
              if (list[i].tagName === item.tagName) {
                list.splice(i, 1);
              }
            }
            list.push(item);
          }
        }),
      );
    });
    let tagList = changeToJson(list);
    setPayloadTags(tagList);
  };

  const changeToJson = tagList => {
    var obj = {};
    tagList.forEach(tags => {
      let item = tags.tagInfo.join(',');
      obj[tags.tagId] = item;
    });
    return obj;
  };

  const updateTagsList = input => {
    const filteredResults = tagValues.map(item => ({
      tagName: item.tagName,
      tagInfo: input
        ? item.tagInfo
          .filter(tag => tag.toLowerCase().includes(input.toLowerCase()) && !selectedTags.includes(tag))
          .slice(0, 10)
        : item.tagInfo.filter(tag => !selectedTags.includes(tag)).slice(0, 10),
    }));

    setModifiedTagsList(filteredResults);
  };

  const updatePageFilter = (e) => {
    if (e >= 1 && e <= 100 || e === "") {
      setPageFilter(e);
    } else {
      message.error(t(MAIL_ROOM_DOCUMENT_FILTERS.RANGE_LIMIT_ERROR.key, MAIL_ROOM_DOCUMENT_FILTERS.RANGE_LIMIT_ERROR.value));
    }
  }

  return (
    <Filters>
      <div className="searchDoc">
        <Search
          placeholder={t(MAIL_ROOM_DOCUMENT_FILTERS.SEARCH_DOCUMENT_PLACEHOLDER.key, MAIL_ROOM_DOCUMENT_FILTERS.SEARCH_DOCUMENT_PLACEHOLDER.value)}
          onPressEnter={() => setSearchByDocName(searchValue)}
          onSearch={() => setSearchByDocName(searchValue)}
          allowClear
          style={{ width: 200 }}
          value={searchValue}
          onChange={e => {
            setSearchValue(e.target.value);
            e.target.value.length === 0 && setSearchByDocName(null);
          }}
        />
        <div className="tagFilter" onClick={() => setShowTags(true)}>
          <Icon type="filter" />
          <p>{t(MAIL_ROOM_DOCUMENT_FILTERS.TAG_FILTER_PLACEHOLDER.key, MAIL_ROOM_DOCUMENT_FILTERS.TAG_FILTER_PLACEHOLDER.value)}</p>
          {selectedTags?.length > 0 && <p className="tagsCount">{selectedTags?.length}</p>}
          {showTags && (
            <Select
              value={selectedTags}
              style={{ width: 200 }}
              mode="multiple"
              open={true}
              dropdownClassName="mailRoomTagsFilter"
              onClick={() => setShowTags(true)}
              onBlur={() => setShowTags(false)}
              onChange={onTagChange}
              onSearch={e => updateTagsList(e)}
              placeholder={t(MAIL_ROOM_DOCUMENT_FILTERS.SELECT_TAG_PLACEHOLDER.key, MAIL_ROOM_DOCUMENT_FILTERS.SELECT_TAG_PLACEHOLDER.value)}
              allowClear
            >
              {modifiedTagsList.map((tags, key) => {
                return (
                  <OptGroup label={tags.tagName} key={key}>
                    {tags.tagInfo.map((tagValue, key) => {
                      return (
                        <Option value={tagValue} key={key}>
                          {tagValue}
                        </Option>
                      );
                    })}
                  </OptGroup>
                );
              })}
            </Select>
          )}
        </div>
      </div>
      <PageFilter>
        <div className='page-filter-title'>
          <p>{t(MAIL_ROOM_DOCUMENT_FILTERS.PAGES_LABEL.key, MAIL_ROOM_DOCUMENT_FILTERS.PAGES_LABEL.value)}</p>
          <InputNumber type="number" min="1" max="100" placeholder="--" onPressEnter={(e) => updatePageFilter(e.target.value)} />
        </div>
      <DateRangeFilter>
        <DateTimePicker
          label={t(MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_FROM_LABEL.key, MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_FROM_LABEL.value)}
          minDate={new Date(moment().subtract(59, 'day'))}
          maxDate={new Date(startAndEndDate.endDate) || new Date()}
          className="dateTimePicker"
          formatStyle="large"
          size="small"
          onChange={value =>
            setStartAndEndDate(prevState => ({
              ...prevState,
              startDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
            }))
          }
          hour24
          value={startAndEndDate.startDate}
          isCentered
        />
        <DateTimePicker
           label={t(MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_TO_LABEL.key, MAIL_ROOM_DOCUMENT_FILTERS.DATE_TIME_PICKER_TO_LABEL.value)}
          minDate={new Date(startAndEndDate.startDate) || new Date(moment().subtract(59, 'day'))}
          maxDate={new Date()}
          className="dateTimePicker"
          formatStyle="large"
          size="small"
          onChange={value =>
            setStartAndEndDate(prevState => ({
              ...prevState,
              endDate: moment(value).format(DEFAULT_DATE_TIME_FORMAT),
            }))
          }
          hour24
          value={startAndEndDate.endDate}
          isCentered
        />
      </DateRangeFilter>
      </PageFilter>
    </Filters>
  );
};

export default withTranslation(NAMESPACES)(FiltersContainer);
